<template>
    <div>
      <div class="experienceItem">
        <div class="itemBox"> 
          <div class="xcxImg">
            <img
              class="img"
              :src="codeUrl"
              alt=""
              style="
                display: block;
                width: 150px;
                height: 150px;
                margin: 0 auto;
              " 
            /> 
          </div>
          <div style="
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            padding: 5px 0;">
            扫码进入刷题小程序
          </div>
          <div style="text-align: center; font-size: 14px;">
            学生注册邀请码 {{ invite_code }}
          </div>
          <div class="btn" @click="imgBtn()">保存图片</div>
          <div v-if="is_open_xcx == '0'" @click="contactFn()" style="text-align: center; font-size: 14px;margin-top: 10px;color: #846FFD;text-decoration: underline;cursor: pointer;">
            暂未开通使用权限，请联系技术人员开通
          </div> 
        </div>  
      </div> 
      <div class="experienceItem2" :ref="pictureId">
        <div class="itemBox"> 
          <div class="xcxImg">
            <img
              class="img"
              :src="codeUrl"
              alt=""
              style="
                display: block;
                width: 150px;
                height: 150px;
                margin: 0 auto;
              " 
            /> 
          </div>
          <div style="
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            padding: 5px 0;">
            扫码进入刷题小程序
          </div>
          <div style="text-align: center; font-size: 14px;">
            学生注册邀请码 {{ invite_code }}
          </div>  
        </div>
      </div>

 
    </div>
  </template>
  <script>
  import commonApi from "@/api/common.js";
  import QRCode from "qrcodejs2";
  import html2canvas from "html2canvas";
  export default {
    data() {
      return {
        qrcode: "",
        qrcode2: "",
        groupName: "",  
        // codeUrl: "",
        group_id: "",
      };
    },
    props: {
      id: {
        type: String,
        required: true,
      }, 
      codeUrl: {
        type: String,
        default: "",
      },
      width: {
        type: String,
        default: "80",
      },
      height: {
        type: String,
        default: "80",
      },
      colorDark: {
        type: String,
        default: "#000000",
      },
      colorLight: {
        type: String,
        default: "#ffffff",
      },
      title: {
        type: String,
        default: "",
      },
      username: {
        type: String,
        default: "",
      },
      password: {
        type: String,
        default: "",
      }, 
      pictureId: {
        type: String,
        required: true,
      },
      code: {
        type: String,
        default: "",
      }, 
      experienceId: {
        type: String,
        required: true,
      }, 
      is_open_xcx: {
        type: String,
        default: "",
      },  
      invite_code: {
        type: String,
        default: "",
      },   
      rechargeClickShow: {
        type: Boolean,
        default: false,
      }, 
    },
    watch: {
      codeUrl(newText) { 
        this.experienceQrcode();
        // this.createQrcode();
      },
      // rechargeClickShow(date){
      //   console.log("rechargeClickShow", date)
      //   this.getActivityXcxCode()
      // }
    },
    created() {
      let _name = this.$store.state.user.userInfo.group.name;
      this.groupName = _name;
      
      // if(localStorage.getItem("group_id")){
      //   this.group_id = localStorage.getItem("group_id") 
      //   this.getActivityXcxCode()
      // }  
    },
    mounted() {
      this.experienceQrcode();
      this.createQrcode();
      // this.createNewQrcode();
    },
    methods: { 
      // // 获取小程序码环境版本
      // getWxcodeEnvVersion(){
      //   if (process.env.NODE_ENV == "production") {
      //       return "release";
      //   } else {
      //       return "trial";
      //   }
      // }, 
      // getActivityXcxCode(){ 
      //   var XcxData = {
      //     scene: this.invite_code,
      //     page: "pages/examIndex",
      //     width: "280",
      //     check_path: false,
      //     is_hyaline: true,
      //     env_version: this.getWxcodeEnvVersion()
      //   }
      //   commonApi.getActivityXcxCode({ 
      //     data:  JSON.stringify(XcxData), 
      //     type: '3', 
      //     invite_code: this.invite_code,
      //     is_oss_url: 1,
      //     group_id: this.group_id
      //   }).then((res) => {
      //     console.log("getActivityXcxCode", res.data.base64); 
      //     this.codeUrl = res.data.oss_url
      //     // localStorage.setItem("codeUrl", this.codeUrl)
      //   });
      // }, 


      contactFn(){ 
        this.$emit("RechargeData", true); 
      },
      createPoster() {
        // 生成海报
        let dom = this.$refs[this.pictureId];
        html2canvas(dom, {
          width: dom.clientWidth, // 生成图片的宽度
          height: dom.clientHeight, // 生成图片的高度
          scale: 2, //scale 将其调大可以解决低分辨率设备下生成的图片模糊问题
          useCORS: true, // 是否允许跨域 如果不行在img标签增加 crossOrigin="Anonymous" 属性
        }).then((canvas) => {
          // 生成一个base64的图片路径
          let dataURL = canvas.toDataURL("image/png");
          let myName = this.title + ".jpg";
          console.log(dataURL);
          this.downloadFile(dataURL, myName);
        });
      },
   
      imgBtn() {
        // 保存图片
        this.createPoster();
      }, 
      downloadFile(url, name) {
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", name);
        a.setAttribute("target", "_blank");
        const clickEvent = document.createEvent("MouseEvents");
        clickEvent.initEvent("click", true, true);
        a.dispatchEvent(clickEvent);
      }, 
      experienceQrcode() { 
        if (this.qrcode2) {
          this.$refs[this.experienceId].innerHTML = "";
        }
        this.qrcode2 = new QRCode(this.$refs[this.experienceId], {
          text: this.codeUrl,
          width: 200,
          height: 200,
          colorDark: this.colorDark,
          colorLight: this.colorLight,
          correctLevel: QRCode.CorrectLevel.H,
        }); 
      },
      // 有新的二维码地址了，先把之前的清除掉
      createQrcode() {
        if (this.qrcode) {
          this.$refs[this.id].innerHTML = "";
        }
        this.qrcode = new QRCode(this.$refs[this.id], {
          text: this.codeUrl,
          width: this.width,
          height: this.height,
          colorDark: this.colorDark,
          colorLight: this.colorLight,
          correctLevel: QRCode.CorrectLevel.H,
        }); 
      }, 
    },
  };
  </script>
  <style lang="less" scoped>
  .experienceItem {
    width: 200px;
    padding: 10px;
    background: #fff;
    .btn{
      border: 1px solid #ddd;
      line-height: 30px;
      cursor: pointer;
      text-align: center;
      width: 100px;
      display: block;
      margin: 0 auto;
      margin-top: 10px; 
    } 

  }

  .experienceItem2 { 
    width: 200px;
    padding: 10px;
    background: #fff;

    text-align: center;
    margin-right: 20px;
    border: 1px solid #dcdfe6;
    background: #FFF;
    position: fixed;
    left: 0;
    top: -500px;
    z-index: 100;
  } 
  
  /deep/.xcxImg{
    .img{
      display: block;
      width: 200px;
      height: 200px;
    }
  }
  </style>
  